const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
  ? JSON.parse(localStorage.getItem("currentUser"))
  : "";
const VATPERCENTAGE = CURRENT_USER_OBJECT[0]?.vatp;

export const countries = [
  {
    code: "+971",
    label: "+971",
    country: "UAE",
    flag: "https://flagcdn.com/w40/ae.png",
  },
  {
    code: "001",
    label: "+1",
    country: "US",
    flag: "https://flagcdn.com/w40/us.png",
  },
  {
    code: "044",
    label: "+44",
    country: "UK",
    flag: "https://flagcdn.com/w40/gb.png",
  },
  {
    code: "0033",
    label: "+33",
    country: "FR",
    flag: "https://flagcdn.com/w40/fr.png",
  },
  {
    code: "0049",
    label: "+49",
    country: "DE",
    flag: "https://flagcdn.com/w40/de.png",
  },
];
export const stockData = [
  {
    id: 1,
    sino: 1,
    code: "",
    description: "",
    location: "",
    unit: "",
    qty: 0,
    UnitPrice: "",
    "Disc%": "",
    DiscountAmount: 0,
    Amount: 0,
    Fraction: "1",
    "vat%": "5",
    vatEnabled: true,
    vatPercent: VATPERCENTAGE,
    "Unit Cost": "",
    dono: "",
    sono: "",
    quotno: "",
    Avlqty: "",
    Vatamt: "",
    BDiscsplit: "",
    total: "",
    oem: "",
    Bin: "",
    discount: "",
    cntrl: "",

    // isIncluded: true,
  },
];

export const purchaseData = [
  {
    id: 1,
    sino: 1,
    code: "",
    description: "",
    location: "",
    unit: "",
    qty: 0,
    unitCost: 0,
    unitBCCost: 0,
    amount: 0,
    othCost: 0,
    x: 0,
    cntrl: 0,
    fraction: 1,
    vatEnabled: true,
    vatPercent: VATPERCENTAGE,
    vatAmount: 0,
    mastInfo: "",
    pono: "",
    total: 0,
    oem: "",
    group: "",
    "Discount%": 0,
    git: "",
    salesperson: "",
    bin: "",
    remarks: "",
    dcp: "",
    isIncluded: true,
    soUid: "",
    isActive: "Yes",
  },
];

export const physicalStockEntryData = [
  {
    id: 1,
    sino: 1,
    code: "",
    description: "",
    location: "",
    unit: "",
    phyQty: 0,
    sysQty: 0,
    variation: 0,
    cost: 0,
    cntrl: 0,
    bin: "",
    group: "",
  },
];
export const workOrderData = [
  {
    id: 1,
    sino: 1,
    code: "",
    description: "",
    location: "",
    unit: "",
    qty: 0,
    unitPrice: 0,
    "Discount%": 0,
    amount: 0,
    x: 0,
    fraction: 1,
    Qno: "",
    oem: "",
    vatEnabled: true,
    vatPercent: VATPERCENTAGE,
    vatAmount: 0,
    total: 0,
    soUid: "",
  },
];
const defaultLocation = localStorage.getItem("departmentLocation") || "A";

export const stockTransferInData = [
  {
    id: 1,
    sino: 1,
    code: "",
    description: "",
    location: defaultLocation,
    unit: "",
    qty: 0,
    unitPrice: 0,
    "Discount%": 0,
    amount: 0,
    x: 0,
    fraction: 1,
    Qno: "",
    oem: "",
    vatEnabled: true,
    vatPercent: VATPERCENTAGE,
    vatAmount: 0,
    total: 0,
    soUid: "",
    billedPrice: 0,
    margin: 0,
    billedAmount: 0
  },
];
export const countriesList = [
  { code: "ae", label: "United Arab Emirates", value: "UAE" },
  { code: "us", label: "United States", value: "USA" },
  { code: "gb", label: "United Kingdom", value: "UK" },
  { code: "in", label: "India", value: "India" },
  { code: "ca", label: "Canada", value: "Canada" },
  { code: "au", label: "Australia", value: "Australia" },
  { code: "de", label: "Germany", value: "Germany" },
  { code: "fr", label: "France", value: "France" },
  { code: "it", label: "Italy", value: "Italy" },
  { code: "cn", label: "China", value: "China" },
  { code: "jp", label: "Japan", value: "Japan" },
  { code: "sa", label: "Saudi Arabia", value: "Saudi Arabia" },
  { code: "br", label: "Brazil", value: "Brazil" },
  { code: "za", label: "South Africa", value: "South Africa" },
  { code: "ru", label: "Russia", value: "Russia" },
  { code: "sg", label: "Singapore", value: "Singapore" },
  { code: "ng", label: "Nigeria", value: "Nigeria" },
  { code: "eg", label: "Egypt", value: "Egypt" },
];
export const returnReasons = [
  {
    reasonOfReturn: [
      "Wrong Part Number",
      "Customer Does Not Need",
      "Damaged Item Received",
      "Incorrect Item Supplied",
      "Quality Issue / Defective Product",
      "Short Shipment",
      "Late Delivery",
      "Duplicate Order",
      "Price Discrepancy",
      "Customer Cancelled Order",
      "Item Not as Described",
      "Wrong Quantity Delivered",
      "Warranty Replacement",
      "Product Expired",
    ],
    conditionOfPart: [
      "New – Unused",
      "Complete – Resellable",
      "Minor Damage / Scratch",
      "Major Damage",
      "Used – Functional",
      "Used – Non-Functional",
      "Missing Components",
      "Refurbished / Repaired",
      "Expired / Obsolete",
      "Original Sealed",
      "Original Packing – Opened",
      "Packing Missing",
      "Damaged Packing",
      "Repacked",
      "No Packing Provided",
      "Soiled / Torn Box",
      "Label Missing or Faded",
    ],
    primaryError: [
      "Supplier Error",
      "Customer Error",
      "Salesperson Error",
      "Warehouse / Packing Error",
      "Dispatch / Logistics Error",
      "System / Data Entry Error",
      "Manufacturing / Quality Error",
      "Unknown / Not Identified",
    ],
    nextAction: [
      "Returned to Supplier",
      "Exchanged with Customer",
      "Kept for Re-Sale",
      "Sent for Warranty Claim",
      "Special Approval from Vendor",
      "Scrap / Write-Off",
      "Awaiting Inspection",
      "Pending Management Approval",
      "Credit Note Issued",
      "Replacement Issued",
    ],
  },
];
export const flagMap = {
  AED: "https://flagcdn.com/w20/ae.png",
  GBP: "https://flagcdn.com/w20/gb.png",
  USD: "https://flagcdn.com/w20/us.png",
  EUR: "https://flagcdn.com/w20/eu.png",
  RMB: "https://flagcdn.com/w20/cn.png",
  INR: "https://flagcdn.com/w20/in.png",
  SAR: "https://flagcdn.com/w20/sa.png",
  AUD: "https://flagcdn.com/w20/au.png",
  CAD: "https://flagcdn.com/w20/ca.png",
  JPY: "https://flagcdn.com/w20/jp.png",
  SGD: "https://flagcdn.com/w20/sg.png",
  ZAR: "https://flagcdn.com/w20/za.png",
  NGN: "https://flagcdn.com/w20/ng.png",
  EGP: "https://flagcdn.com/w20/eg.png",
  BRL: "https://flagcdn.com/w20/br.png",
  RUB: "https://flagcdn.com/w20/ru.png",
  CHF: "https://flagcdn.com/w20/ch.png",
  MYR: "https://flagcdn.com/w20/my.png",
  NZD: "https://flagcdn.com/w20/nz.png",
};

export const mockGroups = [
  {
    id: 1,
    name: "Assets",
    ledgers: [
      {
        type: 1100,
        description: "Cash",
        sublist: [{ account: "0001", description: "test1" }],
      },
      {
        type: 1101,
        description: "Bank",
        sublist: [{ account: "0001", description: "test2" }],
      },
      {
        type: 1102,
        description: "Inventory",
        sublist: [{ account: "0001", description: "test3" }],
      },
    ],
  },
  {
    id: 2,
    name: "Liabilities",
    ledgers: [
      {
        type: 2100,
        description: "Loans",
        sublist: [{ account: "0001", description: "test1" }],
      },
      {
        type: 2101,
        description: "Accounts Payable",
        sublist: [{ account: "0001", description: "test2" }],
      },
    ],
  },
  {
    id: 3,
    name: "Equities",
    ledgers: [
      {
        type: 3100,
        description: "Loans",
        sublist: [{ account: "0001", description: "test1" }],
      },
      {
        type: 2101,
        description: "Accounts Payable",
        sublist: [{ account: "0001", description: "test2" }],
      },
    ],
  },
  {
    id: 4,
    name: "Income",
    ledgers: [
      {
        description: "Sales",
        sublist: [{ account: "42342", description: "3534" }],
      },
    ],
  },
  {
    id: 5,
    name: "Direct Expenses",
    ledgers: [
      {
        description: "Raw materials",
        sublist: [{ account: "42342", description: "3534" }],
      },
    ],
  },
  {
    id: 6,
    name: "Indirect Expenses",
    ledgers: [
      {
        description: "Rent",
        sublist: [{ account: "42342", description: "3534" }],
      },
    ],
  },
];
